import { Vector3 } from '@babylonjs/core/Maths/math.vector';
import { TransformNode } from '@babylonjs/core/Meshes/transformNode';

import { SystemLayer } from '../../../System/systemLayer';
import { PatternMesh } from '../Mesh/patternMesh';
import { PatternTransform } from '../patternTransform';

export class PatternGroup extends PatternTransform {
    protected scaleParent: TransformNode;

    protected center: Vector3;

    public patternMeshes: PatternMesh[] = [];

    constructor(systemLayer: SystemLayer) {
        super(systemLayer);
        const mesh = new TransformNode('group_parent', systemLayer.scene);
        this.initMesh(mesh);
        this.scaleParent = new TransformNode('group_scale', systemLayer.scene);
        this.scaleParent.parent = mesh;
    }

    public listenEvent(bool: boolean): void {
        this.patternMeshes.forEach((pM) => {
            pM.listenEvent(bool);
        });
    }

    protected maximum: Vector3;

    protected minimum: Vector3;

    protected getCenter(): void {
        if (this.minimum === undefined) return;
        const sum = this.maximum.add(this.minimum);
        this.center = sum.divide(new Vector3(2, 2, 2));
    }

    protected checkBounds(): void {
        if (this.patternMeshes[0] === undefined) return;
        this.patternMeshes.forEach((pM) => {
            const boundingInfo = pM.mesh.getHierarchyBoundingVectors();
            if (this.minimum === undefined) {
                this.maximum = boundingInfo.max;
                this.minimum = boundingInfo.min;
            } else {
                this.maximum.maximizeInPlace(boundingInfo.max);
                this.minimum.minimizeInPlace(boundingInfo.min);
            }
        });
    }

    // Extend mesh with group
    private setAllPatternMeshesParam(
        what: string,
        value1?: any,
        value2?: any,
        value3?: any,
        value4?: any
    ): void {
        // for functions called during mesh construction
        if (this.patternMeshes === undefined) return;
        this.patternMeshes.forEach((pM) => {
            pM[what](value1, value2, value3, value4);
        });
    }

    // Use parent setenabled to really show/hide group
    public show(): void {
        this.setAllPatternMeshesParam('show');
    }

    public hide(): void {
        this.setAllPatternMeshesParam('hide');
    }

    public deleteMaterial(): void {
        // this.setAllPatternMeshesParam('deleteMaterial');
    }

    public setMaterialProperties(prop: any): void {
        this.setAllPatternMeshesParam('setMaterialProperties', prop);
    }

    public setMaterialProperty(key: string, value: any): void {
        this.setAllPatternMeshesParam('setMaterialProperty', key, value);
    }

    public removeMaterialProperties(): void {
        this.setAllPatternMeshesParam('removeMaterialProperties');
    }

    public removeMaterialProperty(key: string): void {
        this.setAllPatternMeshesParam('removeMaterialProperty', key);
    }

    public setTintColor(color: number[]): void {
        this.setAllPatternMeshesParam('setTintColor', color);
    }

    public resetTintColor(): void {
        this.setAllPatternMeshesParam('resetTintColor');
    }

    public setTextureUrl(type: string, textureUrl: string): void {
        this.setAllPatternMeshesParam('setTextureUrl', type, textureUrl);
    }

    public destroy(): void {
        this._destroyMeshes();
        this.scaleParent.dispose(true);
        this.mesh.dispose(true);
    }

    protected _destroyMeshes(): void {
        // Avoid to destroy because it will delete used materials
        // this.setAllPatternMeshesParam('destroy');
        if (this.patternMeshes) {
            this.patternMeshes.forEach((pM) => {
                pM.mesh.parent = undefined;
                try { // Can create bug some times
                    pM.mesh.dispose();
                } catch (e) {
                    console.log(e);
                }
            });
        }
        this.patternMeshes = [];
        this.maximum = undefined;
        this.minimum = undefined;
    }
}
